const RETOOL_BASE = 'https://retool.starmountaincapital.com';
const BRANCH = import.meta.env.VITE_RETOOL_BRANCH;

const buildRetoolUrl = (appId: string, path: string) => {
  // Hide navigation UI elements
  const queryParams = '?_hideNav=true';

  if (BRANCH) {
    return `${RETOOL_BASE}/tree/${encodeURIComponent(BRANCH)}/apps/${appId}/${path}${queryParams}`;
  }
  return `${RETOOL_BASE}/apps/${appId}/${path}${queryParams}`;
};

const SOAL_DEV_APP = '3b05158e-9dfa-11f0-8518-4f4f4f73e204';
const SOAL_DEV_REPORTS_APP = 'b05380d0-cad9-11f0-ad22-43b717afde30';
const SMC_ERP_APP = 'f5343a66-f03a-11ef-a13b-5bb8c1f35c61';

export const RETOOL_URLS = {
  home: buildRetoolUrl(SMC_ERP_APP, 'Soal%20Development/home'),
  investments: {
    allocations: buildRetoolUrl(
      SOAL_DEV_APP,
      'Soal%20Development/Investments/allocations'
    ),
    direct: buildRetoolUrl(
      SOAL_DEV_APP,
      'Soal%20Development/Investments/direct_investments'
    ),
    funds: buildRetoolUrl(SMC_ERP_APP, 'SMC%20ERP/funds'),
    pipelines: buildRetoolUrl(SMC_ERP_APP, 'SMC%20ERP/pipelines'),
    rva: buildRetoolUrl(SMC_ERP_APP, 'SMC%20ERP/rva'),
    secondary: buildRetoolUrl(SMC_ERP_APP, 'SMC%20ERP/secondary_deals')
  },
  portfolio: {
    monitoring: buildRetoolUrl(SMC_ERP_APP, 'SMC%20ERP/portfolio'),
    reports: buildRetoolUrl(
      SOAL_DEV_REPORTS_APP,
      'Soal%20Development/Reports/reports'
    ),
    rocky: buildRetoolUrl(SMC_ERP_APP, 'SMC%20ERP/rocky')
  },
  workflows: {
    processes: buildRetoolUrl(SMC_ERP_APP, 'SMC%20ERP/processes'),
    timeline: buildRetoolUrl(SMC_ERP_APP, 'SMC%20ERP/timeline'),
    todo: buildRetoolUrl(SMC_ERP_APP, 'SMC%20ERP/to_do')
  }
};

export const RETOOL_COMMON_PROPS = {
  allow: 'camera; microphone; geolocation; clipboard-write',
  styling: {
    border: 'none',
    height: '100%',
    width: '100%'
  }
};
